import React, { Component } from 'react'
import { connect } from 'react-redux'
import Stix from './Stix'
import PropTypes from 'prop-types'
import * as actions from './actions'

class StixContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    this.props.toggleSupplierId(
      (this.props.match &&
        this.props.match.params &&
        this.props.match.params.supplierId) ||
        null
    )
  }

  // #region [life cycle]

  componentDidMount () {
    this.props.getPartners()
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)

    if (this.props.supplierId !== null) {
      this.props.getMileageConfigurations(
        this.props.catalogId,
        this.props.supplierId
      )
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.supplierId !== this.props.supplierId) {
      this.props.getMileageConfigurations(
        this.props.catalogId,
        this.props.supplierId
      )
    }
  }

  // #endregion

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  render () {
    // @ts-ignore
    return <Stix isMobile={this.state.width <= 480} supplierId={this.props.supplierId} />
  }
}

const mapStateToProps = ({ stix, catalog, mileage }) => ({
  catalogId: catalog.id,
  supplierId: stix.supplierId,
  redemptionPoints: stix.redemptionPoints,
  mileageIsLoading: mileage.isLoading,
  configuration: stix.configuration
})

const mapDispatchToProps = dispatch => ({
  getMileageConfigurations: (catalogId, supplierId) => dispatch(actions.getMileageConfigurations(catalogId, supplierId)),
  toggleSupplierId: supplierId => dispatch(actions.toggleSupplierId(supplierId)),
  getPartners: () => dispatch(actions.getPartnersStix())
})

StixContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      supplierId: PropTypes.string
    })
  }),
  supplierId: PropTypes.string,
  catalogId: PropTypes.number,
  toggleSupplierId: PropTypes.func,
  getMileageConfigurations: PropTypes.func,
  getPartners: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(StixContainer)



// WEBPACK FOOTER //
// ./src/features/Stix/StixContainer.js